import { testimonials } from "@/mocks/homeData";

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      className="py-20 md:py-28 lg:py-32 bg-stem-cream"
    >
      <div className="section-padding max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="label text-revelBlue mb-3 block">
            What Educators Say
          </span>
          <h2 className="heading-lg text-stem-dark mb-4">Testimonials</h2>
          <p className="body-lg text-stem-gray">
            I am grateful for the incredible teachers and mentors who have
            guided me and believed in my potential.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-6 md:p-7 border border-stem-sand hover:border-revelBlue/20 transition-all duration-300 hover:shadow-md"
            >
              <p className="text-sm md:text-base text-stem-charcoal leading-relaxed mb-6">
                "{t.text}"
              </p>
              <div>
                <div className="font-semibold text-stem-dark text-sm">
                  {t.name}
                </div>
                <div className="text-xs text-stem-gray">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
